import {
  agreeMentsStatusFilters,
  documentsSubType,
} from "@/common/const/filter-options";
import { ColumnsStrategy } from "@/common/types";
import DocumentStatusSelect from "@/components/DocumentStatusSelect/DocumentStatusSelect";
import DocumentElementActions from "@/components/DocumentsList/Actions/DocumentElementActions";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  FilterSelect,
  TableCellWithTime,
} from "@/components/TableComponents";
import SortComponent from "@/components/TableComponents/Head/SortComponent";

const agreementTable: ColumnsStrategy[] = [
  {
    label: (
      <FilterSelect
        values={documentsSubType}
        fieldName="filters-subType"
        key="Document type"
      />
    ),
    name: "subType",
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn
        text={
          documentsSubType.find((subType) => subType.value === value)?.label ??
          null
        }
        key={record.id}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Description" key="description" />,
    name: "description",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn text={value} key={record.id} />
    ),
  },
  {
    label: (
      <SortComponent
        key="signedAt"
        childKey="signedAt"
        title="Signed Date"
        tooltipVariants={["From newest to oldest", "From oldest to newest"]}
      />
    ),
    name: "signedAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: (
      <SortComponent
        key="expireAt"
        childKey="expireAt"
        title="Expiry Date"
        tooltipVariants={["From newest to oldest", "From oldest to newest"]}
      />
    ),
    name: "expireAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: (
      <SortComponent
        key="uploadedAt"
        childKey="uploadedAt"
        title="Upload Date"
        tooltipVariants={["From newest to oldest", "From oldest to newest"]}
      />
    ),
    name: "uploadedAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: (
      <FilterSelect
        values={agreeMentsStatusFilters}
        fieldName="filters-status"
        key="status"
      />
    ),
    name: "status",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DocumentStatusSelect
        id={record.id}
        value={value}
        options={agreeMentsStatusFilters}
        key={record.id}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Actions" key="actions" />,
    name: "id",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (_, record) => (
      <DocumentElementActions data={record} key={record.id} />
    ),
  },
];
export default agreementTable;
